import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-primary-50 dark:bg-primary-950">
      <AppHeader />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
